import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Loader from '../../../../../common/Loader';
import PopupWrapper from '../common/PopupWrapper';
import InsurancesInfo from '../../../../../InsurancesInfo';
import DescriptionSection from '../common/DescriptionSection';

import useFetchToDoTaskInsurancesData from '../../hooks/useFetchToDoTaskInsurancesData';

import { INSURANCE_FLOW_TYPE } from '../../../../../../constants/insurance-flow-type';

import styles from './index.styl';

const CompletedInsuranceToDoTaskPopup = ({ task, taskId, onClose, userId }) => {
  const { formatMessage } = useIntl();

  const {
    todoTask,
    taskAssigneeId,
    taskAssigneeFullName,
    itemId,
    hasAdditionalPatientInsurances,
  } = task || {};

  const { description, links } = todoTask || {};

  const { isInsuranceRelatedDataFetching } = useFetchToDoTaskInsurancesData({
    userId,
    hasAdditionalPatientInsurances,
    todoTaskAssignmentId: taskId,
    isCompleted: true,
  });

  const toDoTaskData = useMemo(
    () => ({
      itemId,
      isCompleted: true,
    }),
    [itemId],
  );

  return (
    <PopupWrapper
      handleClose={onClose}
      taskId={taskId}
      formatMessage={formatMessage}
      task={task}
      title={formatMessage({ id: 'task.completed' })}
    >
      <div className={styles.content}>
        <div className={styles.descriptionSection}>
          <DescriptionSection description={description} links={links} />
        </div>

        {isInsuranceRelatedDataFetching ? (
          <Loader />
        ) : (
          <InsurancesInfo
            flowType={INSURANCE_FLOW_TYPE.TO_DO}
            withSelfPayEnding
            userId={taskAssigneeId}
            userName={taskAssigneeFullName}
            toDoTaskData={toDoTaskData}
          />
        )}
      </div>
    </PopupWrapper>
  );
};

CompletedInsuranceToDoTaskPopup.propTypes = {
  onClose: PropTypes.func,
  task: PropTypes.object,
  taskId: PropTypes.number,
  userId: PropTypes.number,
};

export default CompletedInsuranceToDoTaskPopup;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InsuranceToDoTaskPopup/components/CompletedInsuranceToDoTaskPopup/index.jsx